import { useEffect, useState } from 'react';
import {makeStyles, Tooltip} from '@material-ui/core';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import UtilService from '../../../../../../helper/service';
import AnalyzeKeyMomentPopOut from '../../../../../atoms/creator/analyzeKeyMomentPopout';
import { updateOnBoardingSettings } from '../../../../../../store/actions/creator/creatorOnBoarding';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    marginBottom: 20,
    height: 74,
    zIndex: 4,
  },
  pillInTime: {
    width: '18px!important',
    height: '18px!important',
    borderRadius: '9px!important',
    margin: -3,
    transition: '0.2s',
  },
  pills: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 0,
    zIndex: 4,
  },
  boxInTime: {
    height: '50px!important',
    marginTop: -4,
    transition: '0.4s',
    marginBottom: 2,
  },
  box: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    fontFamily: 'roboto-bold',
    fontSize: 18,
    borderRadius: 8,
    height: 45,
    zIndex: 4,
    '&:hover': {
      cursor: 'pointer',
      height: 52,
      marginTop: -3,
      transition: '0.4s',
      marginBottom: -4,
    },
    marginRight: 2,
  },
  section: {
    display: 'flex',
    flexDirection: 'row',
    height: 16,
    marginBottom: 3,
  },
  pill: {
    position: 'absolute',
    width: 14,
    height: 14,
    borderRadius: 7,
    background: 'grey',
    '&:hover': {
      width: 18,
      height: 18,
      borderRadius: 9,
      margin: -3,
      transition: '0.2s',
      cursor: 'pointer',
    },
  },
}));

function PillSection(props: any) {

  const classes = useStyles();
  const tooltipClasses = useStylesTooltip();
  const { module4Settings, userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { module4Data } = userPreferences;
  const { session, analyze } = module4Data.value;
  const { graphZoom, videoPopIn, analyseStart, timeline } = module4Settings;
  const stimulus = analyze.stimulus;
  const { graphWidth, graphData, clip, videoPlayed, onZoom, popOut, marginTop, onPillClicked } = props;
  const { session_type } = session;
  const { psych_readiness } = analyze;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [overlay, setOverlay] = useState<any>(null);
  const start =  0
  const graphStart = analyseStart;
  const { pills } = graphData;
  const dispatch = useDispatch();

  useEffect(() => {
    if (timeline) {
      const hasKey = timeline?.epoch_start
        ? document.getElementById("key_" + timeline?.epoch_start)
        : document.getElementById("segment_" + timeline?.start_marker_at)

      if (hasKey) {
        setTimeout(() => {
          hasKey.click();

          if (session_type === 'ASYNC') {
            popOut && popOut(timeline?.start ? timeline.start : timeline?.epoch_start);
          }

          if (session_type === 'MODERATED' && stimulus) {
            popOut && popOut(timeline?.start ? (timeline.start - graphStart + start) : (timeline?.epoch_start - graphStart + start));
          }
        }, 2000);

        dispatch(updateOnBoardingSettings('timeline', null))

      }
    }
  }, [timeline])

  const handlePillClick = async (event: any, data: any, type: string) => {
    onPillClicked();
    setOverlay(null);
    const isPill = data?.start === 0 || data?.start !== undefined;
    const param = { ...data }
    const started_time = isPill ? data.start : data?.epoch_start
    const ended_time = data?.end ? data.end : data?.epoch_end
    const segment_start = started_time - (session_type === 'ASYNC' ? 0 : graphStart);
    const segment_end = ended_time - (session_type === 'ASYNC' ? 0 : graphStart);

    if (session_type === 'ASYNC') {
      popOut && popOut(started_time);
    }

    if (session_type === 'MODERATED') {
      popOut && popOut(isPill ? (data.start - graphStart + start) : (data?.epoch_start - graphStart + start));
    }

    param['color'] = data?.pill ? data.pill : data?.color_indicator;
    param['type'] = type;
    param['segment_start'] = UtilService.getTimeLabel(segment_start, 1, session_type === 'ASYNC' ? 0 : start);
    param['segment_end'] = UtilService.getTimeLabel(segment_end, 1, session_type === 'ASYNC' ? 0 : start);
    param['segment_length'] = UtilService.getTimeLabel(segment_end - segment_start, 1, 0);
    param['length'] = segment_end - segment_start;
    param['start'] = isPill ? data.start : data?.epoch_start;
    param['end'] = ended_time;

    setAnchorEl(event && event.currentTarget);
    const matchedSafety = psych_readiness.find((safety: any) => (safety.epoch_start + 120 > ended_time) && (safety.epoch_start < ended_time))

    if(matchedSafety && matchedSafety.immersion_index !== 1){
      param['safety_color'] = matchedSafety.color_indicator;
      param['safety_index'] = matchedSafety.immersion_index;
      param['safety_indicator'] = matchedSafety.context_indicator;
    }else{
      param['safety_color'] = 'gray';
      param['safety_index'] = '--';
      param['safety_indicator'] = '';
    }

    setOverlay(param);
  };

  if (!pills) {
    return null
  }

  const newPills: any = [];

  if (pills && pills[0]?.moment && stimulus) {
    newPills.push({
      pill: "blank",
      start: 0,
      end: stimulus.stimulus_video_length,
      overall_index: '--',
      tier_indicator: "High",
      color_indicator: "gray",
      context_indicator: "",
      moments: pills
    });
  }

  return (
    <div className={classes.root} style={{
      marginTop: clip ? -85 : -131,
      width: graphWidth
    }}>
      <div
        className={classes.pills}
        style={{
          width: graphWidth,
          marginTop: marginTop ? marginTop : (stimulus ? 24 : 21)
        }}
      >
        {
          (newPills.length === 1 ? newPills : pills).map((item: any, index: number) => {

            let start = item.start ? item.start : item.epoch_start;
            let end = item.end ? item.end : item.epoch_end;
            if (!start) {
              start = 0;
            }
            if (!end) {
              end = 0;
            }

            const getPosition = (c: any) => {
              return (c.epoch_start - (session_type === 'ASYNC' ? 0 : graphStart)) * 15 / Math.pow(graphZoom, 2);
            }

            const isPillInArea = (c: any) => {
              const pillTime = stimulus
                ? (session_type === 'MODERATED' ? (videoPlayed + analyseStart) : videoPlayed)
                : videoPopIn + analyseStart
              return (c.epoch_start <= pillTime && c.epoch_start + graphZoom * 2 >= pillTime);
            }

            const isSegmentInTime = (segment: any) => {
              const pillTime = stimulus
                ? (session_type === 'MODERATED' ? videoPlayed + analyseStart : videoPlayed)
                : videoPopIn + analyseStart
              return (segment.start <= pillTime && segment.end > pillTime);
            }

            return (
              <div key={index} style={{ position: 'absolute', marginBottom: 45 }}>
                <div className={classes.section}>
                  {item?.moments && item?.moments.map((c: any, k: number) => {
                      return (
                        <Tooltip key={k} classes={tooltipClasses} title="Click for Key Moment details" placement="bottom" arrow>
                          <div
                            id={"key_" + c.epoch_start}
                            className={clsx(classes.pill, isPillInArea(c) && classes.pillInTime)}
                            onClick={(e) => handlePillClick(e, c, 'Key Moment')}
                            style={{
                              background: UtilService.refactorGraphColor(c.moment),
                              left: getPosition(c)
                            }}
                          />
                        </Tooltip>
                        )
                  })}
                </div>

                {item.overall_index > 0 && item.pill !== 'Blank' && (
                  <Tooltip classes={tooltipClasses} title="Click for Segment details" placement="bottom" arrow>
                    <div
                      aria-describedby={'simple-popover'}
                      className={clsx(classes.box, isSegmentInTime(item) && classes.boxInTime)}
                      id={"segment_" + item.start}
                      style={{
                        left: (start - (session_type === 'ASYNC' ? 0 : graphStart)) * 15 / Math.pow(graphZoom, 2),
                        width: (end - start) * 15 / Math.pow(graphZoom, 2),
                        background: UtilService.refactorGraphColor(item.pill)
                      }}
                      onClick={(e) => handlePillClick(e, item, 'Segment')}
                    >
                      {(end - start) / Math.pow(graphZoom, 2) > 5 && <img src={'/assets/icons/liveanalysis/graph-icon.svg'} alt={'icon'} style={{ marginRight: 5 }} />}
                      {(end - start) / Math.pow(graphZoom, 2) > 2 && (end > start) && item.overall_index}
                    </div>
                  </Tooltip>
                )}
              </div>)
          })
        }
      </div>
      {
        overlay?.color &&
        <AnalyzeKeyMomentPopOut
          anchorEl={anchorEl}
          overlay={overlay}
          onZoom={onZoom}
          setAnchorEl={setAnchorEl}
          onboarding={true}
        />
      }
    </div>
  );
}

export default PillSection;

const useStylesTooltip = makeStyles(() => ({
  arrow: {
    color: '#393C41'
  },
  tooltip: {
    backgroundColor: '#393C41'
  }
}));